// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4":"f0c55ffc","456":"5e44a561","620":"bf18e318"}[chunkId] + ".chunk.css";
};